import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bib-rules"
export default class extends Controller {
  static targets = ["wrapper", "template"]

  addField(event) {
    event.preventDefault()
    const content = this.templateTarget.content.cloneNode(true)
    this.wrapperTarget.appendChild(content)
  }

  removeField(event) {
    event.preventDefault()
    event.target.closest(".category-field").remove()
  }
}
